export class PromiseQueue {
  private queue: ((...args: any[]) => Promise<void>)[];
  private isProcessing: boolean;

  constructor() {
    this.queue = [];
    this.isProcessing = false;
  }

  /**
   * Adds a promise-returning function to the queue.
   * @param {Function} promiseFn - A function that returns a promise.
   */
  enqueue(promiseFn: (...args: any[]) => Promise<void>) {
    this.queue.push(promiseFn);
    this.processQueue();
  }

  /**
   * Processes the queue if not already processing.
   */
  async processQueue(): Promise<void> {
    if (this.isProcessing) return;

    this.isProcessing = true;

    while (this.queue.length > 0) {
      const currentPromiseFn = this.queue.shift();
      if (!currentPromiseFn) continue;

      await currentPromiseFn();
    }

    this.isProcessing = false;
  }

  /**
   * Clears the queue and stops processing.
   */
  clearQueue(): void {
    this.queue = [];
    this.isProcessing = false;
  }
}
